// src/components/settings/sections/ContentFooterSection.jsx
import React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormInput from '../../inputs/FormInput';
import { getAccordionStyles } from './accordionStyles';

const ContentFooterSection = ({
    expanded,
    handleAccordionChange,
    isDark,
    formData,
    handleTextChange,
    showArabic,
    showEnglish,
}) => {
    const { accordionBaseSx, summarySx, detailsSx } = getAccordionStyles(isDark);

    return (
        <Accordion
            expanded={expanded === 'content'}
            onChange={handleAccordionChange('content')}
            disableGutters
            elevation={0}
            square={false}
            sx={accordionBaseSx}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: isDark ? '#93C5FD' : '#1D4ED8' }} />}
                sx={summarySx}
            >
                <Typography fontWeight={600} sx={{ color: isDark ? '#E5E7EB' : '#0F172A', fontSize: 15 }}>
                    Content & Footer
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={detailsSx}>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 1 }}>
                    {showArabic && (
                        <Box sx={{ flex: 1, minWidth: 220 }}>
                            <FormInput
                                type="text"
                                name="contact_us_ar"
                                label="نص تواصل (عربي)"
                                labelBio="نص تواصل بالعربي"
                                value={formData.contact_us_ar}
                                onChange={handleTextChange}
                                fullWidth
                                required={false}
                            />
                        </Box>
                    )}
                    {showEnglish && (
                        <Box sx={{ flex: 1, minWidth: 220 }}>
                            <FormInput
                                type="text"
                                name="contact_us_en"
                                label="Contact text (EN)"
                                labelBio="Contact text in English"
                                value={formData.contact_us_en}
                                onChange={handleTextChange}
                                fullWidth
                                required={false}
                            />
                        </Box>
                    )}
                    {showArabic && (
                        <Box sx={{ flex: 1, minWidth: 220 }}>
                            <FormInput
                                type="text"
                                name="footer_bio_ar"
                                label="نص الفوتر (عربي)"
                                labelBio="نص الفوتر بالعربي"
                                value={formData.footer_bio_ar}
                                onChange={handleTextChange}
                                required={false}
                            />
                        </Box>
                    )}
                    {showEnglish && (
                        <Box sx={{ flex: 1, minWidth: 220 }}>
                            <FormInput
                                type="text"
                                name="footer_bio_en"
                                label="Footer text (EN)"
                                labelBio="Footer text in English"
                                value={formData.footer_bio_en}
                                onChange={handleTextChange}
                                required={false}
                            />
                        </Box>
                    )}
                </Box>
            </AccordionDetails>
        </Accordion>
    );
};

export default ContentFooterSection;
